import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='security-and-privacy-intro'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col
        medium={10}
        large={8}>
        <Typography
          component='h1'
          align='center'
          nextElement='typography'>
          Information Protection
        </Typography>
        <Typography disableBottomPadding>
          Northwestern Mutual takes the privacy and security of your personal information seriously. It is our mission to protect our client&#39;s information and maintain their trust through delivery of innovative cybersecurity and risk management services.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
